// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__OUZhM","body":"Contact_body__spYUm","formControlLabel":"Contact_formControlLabel__TymVg","checkboxLabel":"Contact_checkboxLabel__i6sSx"};